module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bank/bni-logo-67261e7bc82a06f2095d006ca9f70d1b.png";